var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "451px",
    height: "451px",
    viewBox: "0 0 451 451",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F1FF00",
    cx: 225.5,
    cy: 225.5,
    r: 225.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(123.000000, 50.000000)",
    stroke: "#000000",
    strokeWidth: 30
  }, /*#__PURE__*/React.createElement("line", {
    x1: 79.5,
    y1: 148,
    x2: 79.5,
    y2: 285.783203,
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 79.5,
    cy: 79.5,
    r: 64.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 196,
    cy: 182,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 80,
    cy: 316,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,286 C79.5,260.529121 106.016723,240.067695 149,236.40492 C191.983277,232.742145 228.190168,218.014534 228.190168,182",
    id: "Path-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircular);
export default __webpack_public_path__ + "static/media/circular.2a60fe7214de2bc2ba4d1695008f5f8e.svg";
export { ForwardRef as ReactComponent };